<template>
  <custom-dialog
    width="1180px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div
      class="dialog-body"
      style="padding-top: 0"
    >
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float: right;">
            <search-input
              v-model="formSearch.keyword"
              :placeholder="$t('fms_add_refund_order.jshhtbh')"
              @fetch="onPageChange({ page: 1 })"
            ></search-input>
          </el-form-item>
        </el-form>
      </div>
      <custom-table
        type="checkbox"
        v-model="tableSelect"
        :data="tableList"
        tableCode="add_refund_record_order"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['action']"
      >
      </custom-table>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="visible = false"
      >{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        size="small"
        :disabled="!this.tableSelect.length"
        type="primary"
        @click="confirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';
import mixins from '@/pages/fms/components/mixins.js';

export default {
  mixins: [languageInjectMixins, dialogMixins, mixins],
  data() {
    return {
      dataTimes: [],
      tableSelect: [],
      formSearch: {
        receivableOrgId: '',
        filterBillIdList: [],
        beginOfPaymentTime: '',
        endOfPaymentTime: '',
        keyword: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        paymentOrReceivable: true,
        isRefundBill: 1
      },
      tableList: [],
      totalRows: 0
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.filterBillIdList = this.model.filterBillIdList;
      this.formSearch.receivableOrgId = this.model.payableOrgId;
      this.formSearch.payableOrgId = this.model.receivableOrgId;
      this.formSearch.beginOfPaymentTime = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.endOfPaymentTime = this.dataTimes ? this.dataTimes[1] : '';
      this.$getJSON(apis.paymentToAddPayablePage, this.formSearch).then((res) => {
        this.tableList = this.formatRefundBill(res.data.records || res.data.list);
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      this.$emit('change', this.tableSelect);
      this.visible = false;
    }
  }
};
</script>

<style lang="scss"></style>
